import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const ArrowRight = ({
  size,
  type,
  theme,
  className,
  dataTestId = "arrow-right-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M8.59386 4.21058C8.33351 3.95023 8.33351 3.52812 8.59386 3.26777C8.85421 3.00742 9.27632 3.00742 9.53667 3.26777L13.7986 7.52972C14.059 7.79007 14.059 8.21218 13.7986 8.47253L9.53667 12.7345C9.27632 12.9948 8.85421 12.9948 8.59386 12.7345C8.33351 12.4741 8.33351 12.052 8.59386 11.7917L11.718 8.66756L2.67204 8.66756C2.30385 8.66756 2.00537 8.36909 2.00537 8.0009C2.00537 7.63271 2.30385 7.33423 2.67204 7.33423L11.7175 7.33423L8.59386 4.21058Z" />
  </SVGIcon>
);
